import { render, staticRenderFns } from "./list-details.vue?vue&type=template&id=87edd26c&scoped=true"
import script from "./list-details.vue?vue&type=script&lang=js"
export * from "./list-details.vue?vue&type=script&lang=js"
import style0 from "./list-details.vue?vue&type=style&index=0&id=87edd26c&prod&lang=scss&scoped=true"
import style1 from "./list-details.vue?vue&type=style&index=1&id=87edd26c&prod&lang=css&scoped=true"
import style2 from "./list-details.vue?vue&type=style&index=2&id=87edd26c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87edd26c",
  null
  
)

export default component.exports